import { TMyLoadsTabs } from './MyLoadsContainer.type';

export const myLoadsTabs: TMyLoadsTabs[] = [
  {
    slug: 'DriverAssigned',
    WebTitle: 'Driver Assigned',
    MobTitle: 'Driver Assigned',
    icon: 'driver.svg',
    icon_select: 'driver.svg',
    selected: true
  },
  {
    slug: 'In-Transit',
    WebTitle: 'In-Transit',
    MobTitle: 'In-Transit',
    icon: 'transit.svg',
    icon_select: 'transit.svg',
    selected: false
  },
  {
    slug: 'Delivered',
    WebTitle: 'Delivered',
    MobTitle: 'Delivered',
    icon: 'delivered.svg',
    icon_select: 'delivered.svg',
    selected: false
  }
];
